// incoming states
// there is available inventory
export const AVAILABLE = 'available';
// the venue is closed
export const CLOSED = 'closed';
// no inventory has been created
export const NOT_AVAILABLE = 'not available';
// all inventory has been purchased
export const SOLD_OUT = 'sold-out';

// resultant states
export const STATE_AVAILABLE = 'available';
export const STATE_CLOSED = 'closed';
export const STATE_PARTIALLY_AVAILABLE = 'partially_available';
export const STATE_SOLD_OUT = 'sold_out';

// icons
const EVENT_ICON = 'event';

function check(...states) {
  return (val) => states.includes(val);
}

function checkAvailable(s) {
  return check(AVAILABLE)(s.reservation);
}

function checkPartiallyAvailable(s) {
  return check(NOT_AVAILABLE, SOLD_OUT)(s.reservation)
    && check(AVAILABLE)(s.experience);
}

function checkSoldOut(s) {
  return check(SOLD_OUT)(s.reservation)
    || check(SOLD_OUT)(s.experience);
}

function evaluate(states) {
  if (checkAvailable(states)) {
    return STATE_AVAILABLE;
  } if (checkPartiallyAvailable(states)) {
    return STATE_PARTIALLY_AVAILABLE;
  } if (checkSoldOut(states)) {
    return STATE_SOLD_OUT;
  }
  return STATE_CLOSED;
}

function calendarStateDeterminer(
  reservation,
  experience
) {
  // all types - reservations, events
  const state = evaluate({
    reservation,
    experience,
  });

  const icon = (experience === AVAILABLE || experience === SOLD_OUT) ? EVENT_ICON : null;

  return {
    state,
    icon,
  };
}

export default calendarStateDeterminer;
